import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CalloutBox } from 'components/Docs/CalloutBox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CalloutBox icon="IconWarning" title="Before you start" type="fyi" mdxType="CalloutBox">
      <ul>
        <li parentName="ul">{`If you use a self-hosted proxy, PostHog can't help troubleshoot. Use `}<a parentName="li" {...{
            "href": "/docs/advanced/proxy/managed-reverse-proxy"
          }}>{`our managed reverse proxy`}</a>{` if you want support.`}</li>
        <li parentName="ul">{`Use domains matching your PostHog region: `}<inlineCode parentName="li">{`us.i.posthog.com`}</inlineCode>{` for US, `}<inlineCode parentName="li">{`eu.i.posthog.com`}</inlineCode>{` for EU.`}</li>
        <li parentName="ul">{`Don't use obvious path names like `}<inlineCode parentName="li">{`/analytics`}</inlineCode>{`, `}<inlineCode parentName="li">{`/tracking`}</inlineCode>{`, `}<inlineCode parentName="li">{`/telemetry`}</inlineCode>{`, or `}<inlineCode parentName="li">{`/posthog`}</inlineCode>{`. Blockers will catch them. Use something unique to your app instead.`}</li>
      </ul>
    </CalloutBox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      